import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { IconGenderMale, IconGenderFemale, IconGenderAgender } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { addAthlete, updateAthlete } from "../../db"; // Import IndexedDB functions

const Athlete = ({ athlete }) => {
    const [sending, setSending] = useState(false);
    const [nickname, setNickname] = useState(athlete?.nickname || "");
    const [firstname, setFirstname] = useState(athlete?.firstname || "");
    const [lastname, setLastname] = useState(athlete?.lastname || "");
    const [height, setHeight] = useState(athlete?.height || "");
    const [weight, setWeight] = useState(athlete?.weight || "");
    const [email, setEmail] = useState(athlete?.email || "");
    const [gender, setGender] = useState(athlete?.gender || "");
    const navigate = useNavigate();

    const { t } = useTranslation();

    useEffect(() => {
        if (athlete) {
            setNickname(athlete.nickname || "");
            setFirstname(athlete.firstname || "");
            setLastname(athlete.lastname || "");
            setEmail(athlete.email || "");
            setGender(athlete.gender || "");
        }
    }, [athlete]);

    const handleSave = async () => {
        const athleteData = { nickname, firstname, lastname, email, gender, height, weight };

        if (isValid()) {
            setSending(true);
            if (athlete) {
                await updateAthlete(athlete.id, athleteData);
                navigate(`/athletes/${athlete.id}`);
            } else {
                await addAthlete(athleteData);
                navigate("/athletes");
            }
        }
    };

    const isValid = () => {
        return true;
    }

    return (
        <div className="flex flex-col gap-6 px-2">
            <div className="pt-4 gap-4 grid sm:grid-cols-2 md:grid-cols-4">
                <div className="flex flex-col gap-2 sm:col-span-2 md:col-span-4">
                    <label htmlFor="newAthleteGender" className="font-bold">
                        {t("athletes.gender")}
                    </label>
                    <div className="flex gap-6">
                        <label htmlFor="newAthleteGenderAgender"
                               className={`p-2 rounded-full cursor-pointer ${gender === "" ? "bg-[var(--dark-color)] text-[var(--light-color)]" : "bg-transparent"}`}
                        >
                            <input type="radio" name="gender" value=""
                                   checked={gender === ""}
                                   onChange={() => setGender("")}
                                   id="newAthleteGenderAgender" className="sr-only" />
                            <IconGenderAgender className="w-6 h-auto" />
                        </label>

                        <label htmlFor="newAthleteGenderFemale"
                               className={`p-2 rounded-full cursor-pointer ${gender === "female" ? "bg-[var(--dark-color)] text-[var(--light-color)]" : "bg-transparent"}`}
                        >
                            <input type="radio" name="gender" value="female"
                                   checked={gender === "female"}
                                   onChange={() => setGender("female")}
                                   id="newAthleteGenderFemale" className="sr-only" />
                            <IconGenderFemale className="w-6 h-auto" />
                        </label>

                        <label htmlFor="newAthleteGenderMale"
                               className={`p-2 rounded-full cursor-pointer ${gender === "male" ? "bg-[var(--dark-color)] text-[var(--light-color)]" : "bg-transparent"}`}
                        >
                            <input type="radio" name="gender" value="male"
                                   checked={gender === "male"}
                                   onChange={() => setGender("male")}
                                   id="newAthleteGenderMale" className="sr-only" />
                            <IconGenderMale className="w-6 h-auto" />
                        </label>
                    </div>
                </div>

                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="newAthleteNickname" className="font-bold">
                        {t("athletes.nickname")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            value={nickname} onChange={(e) => setNickname(e.target.value)}
                            id="newAthleteNickname"
                        />
                    </div>
                </div>
                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="newAthleteFirstname" className="font-bold">
                        {t("athletes.firstname")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            value={firstname} onChange={(e) => setFirstname(e.target.value)}
                            id="newAthleteFirstname"
                        />
                    </div>
                </div>
                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="newAthleteLastname" className="font-bold">
                        {t("athletes.lastname")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            value={lastname} onChange={(e) => setLastname(e.target.value)}
                            id="newAthleteLastname"
                        />
                    </div>
                </div>
                <div className="flex flex-col gap-2 sm:col-span-2">
                    <label htmlFor="newAthleteEmail" className="font-bold">
                        {t("athletes.email")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            value={email} onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            inputMode="email"
                            id="newAthleteEmail"
                        />
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <label htmlFor="newAthleteHeight" className="font-bold">
                        {t("athletes.height")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            value={height} onChange={(e) => setHeight(e.target.value)}
                            type="number"
                            inputMode="decimal"
                            id="newAthleteHeight"
                            className="!pr-8"
                        />
                        <div className="form-input-icon pr-6 font-bold">cm</div>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <label htmlFor="newAthleteWeight" className="font-bold">
                        {t("athletes.weight")}
                    </label>
                    <div className="form-input-wrap">
                        <input
                            value={weight} onChange={(e) => setWeight(e.target.value)}
                            type="number"
                            inputMode="decimal"
                            id="newAthleteWeight"
                            className="!pr-8"
                        />
                        <div className="form-input-icon pr-6 font-bold">kg</div>
                    </div>
                </div>
            </div>
            <div className="">
                {sending ? (
                    <button className="button-primary" disabled>{t("athletes.save")}</button>
                ) : (
                    <button onClick={handleSave} className="button-primary">{t("athletes.save")}</button>
                )}
    </div>
        </div>
    );
};

export default Athlete;